// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FoZl","placeholdersHeader":"styles_placeholdersHeader__3DL91","editorStyle":"styles_editorStyle__34f6b","placeholdersBox":"styles_placeholdersBox__3BLLk"};